module.exports = __webpack_public_path__ + "assets/share.3c6cbf0a.svg";